<template>
  <b-modal
    id="annonce-delete-modal-in-progress"
    ref="modal"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Ok')"
    centered
    hide-header
    ok-variant="primary"
    @cancel="hideModal"
    @close="hideModal"
    @ok="handleOk">

    <div class="delete-container">
      <div class="d-flex justify-content-between align-items-center mb-4">
      <span
        class="page-title"> {{
          $t('annonce.already.askedToBeDeleted.title')
        }} </span>
        <i class="ph-custom ph-x-bold cursor" @click="hideModal"/>
      </div>

      <div class="mb-4">
        {{ $t('annonce.already.askedToBeDeleted.message') }}
      </div>
    </div>
  </b-modal>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'AnnonceDeleteModal',

  methods: {

    handleOk(bvModalEvt) {
      this.handleSubmit()
    },

    handleSubmit() {
      this.hideModal()
    },

    hideModal() {
      this.$bvModal.hide('annonce-delete-modal-in-progress')
    },
  },

}
</script>

<style>
.cursor:hover {
  cursor: pointer;
}

/** pour éviter les 17px de padding qui s'ajoutent en responsive */
#annonce-delete-modal-in-progress {
  padding-left: 0px !important;
}

#annonce-delete-modal-in-progress .modal-content,
#annonce-delete-modal-in-progress .modal-header,
#annonce-delete-modal-in-progress .modal-body,
#annonce-delete-modal-in-progress .modal-footer {
  background-color: var(--main-black-dark) !important;
}

#annonce-delete-modal-in-progress .modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  padding: 0;
  border-bottom: none;
}


#annonce-delete-modal-in-progress .modal-content {
  overflow: hidden;
  border-radius: 30px;
}


@media (max-width: 767px) {
  #annonce-delete-modal-in-progress .modal-content {
    display: flex;
    border-radius: 0px;
    overflow: auto;
  }

  #annonce-delete-modal-in-progress .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #annonce-delete-modal-in-progress .modal-body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  #annonce-delete-modal-in-progress .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #annonce-delete-modal-in-progress .modal-content {
    padding: 0;
    border-radius: 0;
  }

  #annonce-delete-modal-in-progress .modal-header-content, .title-share-container {
    padding: 10px;
  }
}


#annonce-delete-modal-in-progress .btn-secondary {
  background-color: var(--main-black-dark) !important;
  border-color: var(--main-grey-light) !important;
  color: var(--main-white);
  border-radius: var(--main-border-radius);
  padding: 12px 20px;
  font-size: var(--content-font-size);
}

#annonce-delete-modal-in-progress .btn-secondary:hover:not([disabled]) {
  background-color: var(--main-black-medium) !important;
}


#annonce-delete-modal-in-progress .copy-clipboard {
  background-color: rgb(51, 51, 51);
}

</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceDeleteModalInProgress.vue